import { Col, Row } from 'antd'
import DraftTable from '../SoundingDraftTemp/DraftTable'
import React from 'react'
import SoundingEquipment from '../SoundingDraftTemp/SoundingEquipment'
import TemperatureTable from '../SoundingDraftTemp/TemperatureTable'

const SoundingDraftTempStep = () => (
  <>
    <SoundingEquipment />
    <Row gutter={24}>
      <Col>
        <DraftTable />
      </Col>
      <Col>
        <TemperatureTable />
      </Col>
    </Row>
  </>
)

export default SoundingDraftTempStep
